import axios from "axios";
import http from "Utils/api2";
import { handleAlert } from "./alertSlice";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// ---------- THUNKS (APIs) ----------
export const getCategory = createAsyncThunk("getCategory", async (url) => {
  try {
    const res = await http.get(url);
    return res.data;
  } catch (error) {
    return { data: null };
  }
});

export const getEcomCategory = createAsyncThunk("getEcomCategory", async (url) => {
  try {
    const res = await http.get(url);
    return res.data;
  } catch (error) {
    return { data: null };
  }
});

export const getSubCategory = createAsyncThunk("getSubCategory", async (url) => {
  try {
    const res = await http.get(url);
    return res.data;
  } catch (error) {
    return { data: null };
  }
});

export const getSubGlobalCategory = createAsyncThunk(
  "getSubGlobalCategory",
  async (url) => {
    try {
      const res = await http.get(`/${url}`);
      return res.data;
    } catch (error) {
      return { data: null };
    }
  }
);

export const getGlobalCategory = createAsyncThunk(
  "getGlobalCategory",
  async ({ adminId, filter, page, limit }) => {
    try {
      const res = await http.get(
        `/eCommerce/getAllCategoryByAdmin/${adminId}?page=${page || 1}&limit=${limit || 10}${filter || ""}`
      );
      return res.data;
    } catch (error) {
      return { data: null };
    }
  }
);

// For infinite scroll - appends results instead of replacing
export const getGlobalCategoryAppend = createAsyncThunk(
  "getGlobalCategoryAppend",
  async ({ adminId, filter, page, limit }) => {
    try {
      const res = await http.get(
        `/eCommerce/getAllCategoryByAdmin/${adminId}?page=${page || 1}&limit=${limit || 10}${filter || ""}`
      );
      return res.data;
    } catch (error) {
      return { data: null };
    }
  }
);

export const getServiceCategory = createAsyncThunk(
  "getServiceCategory",
  async ({ page }) => {
    try {
      const res = await http.get(
        `/getAllCategory?page=${page ?? 1}&limit=10`
      );
      return res.data;
    } catch (error) {
      return { data: [], totalPages: 1 };
    }
  }
);

export const getNullParentCategory = createAsyncThunk(
  "getNullParentCategory",
  async (adminId) => {
    try {
      const res = await http.get(`/getAllNullPcategory/${adminId}`);
      return res.data;
    } catch (error) {
      return { data: null };
    }
  }
);

export const getSubcategoryByPcategory = createAsyncThunk(
  "getSubcategoryByPcategory",
  async ({ pCategory, adminId }) => {
    try {
      const res = await http.get(`/getCategoryWithPcategory/${pCategory}/${adminId}`);
      return res.data;
    } catch (error) {
      return { data: null };
    }
  }
);

export const updateCategory = createAsyncThunk(
  "updateCategory",
  async ({ url, data, notFormData }) => {
    const res = await http.put(url, data, {
      headers: {
        "Content-Type": notFormData
          ? "application/json"
          : "multipart/form-data",
      },
    });
    return res.data;
  }
);

export const disableServiceCategory = createAsyncThunk(
  "disableServiceCategory",
  async ({ url, data, notFormData }) => {
    const res = await http.patch(url, data, {
      headers: {
        "Content-Type": notFormData
          ? "application/json"
          : "multipart/form-data",
      },
    });
    return res.data;
  }
);

export const approveCategoryStatus = createAsyncThunk(
  "approveCategoryStatus",
  async ({ categoryId, adminId }) => {
    try {
      const res = await http.patch(`/admin/approveCategory/${categoryId}/${adminId}`);
      return res.data;
    } catch (error) {
       return error.response?.data || { success: false, message: "Something went wrong" };
    }
  }
);

export const rejectCategoryStatus = createAsyncThunk(
  "rejectCategoryStatus",
  async ({ categoryId, adminId, reason }) => {
    try {
      const res = await http.patch(`/admin/rejectCategory/${categoryId}/${adminId}`, { reason });
      return res.data;
    } catch (error) {
      return error.response?.data || { success: false, message: "Something went wrong" };
    }
  }
);


export const disableCategory = createAsyncThunk(
  "disableCategory",
  async ({ url, data, notFormData }) => {
    const res = await http.patch(url, data, {
      headers: {
        "Content-Type": notFormData
          ? "application/json"
          : "multipart/form-data",
      },
    });
    return res.data;
  }
);

export const unlinkImage = createAsyncThunk(
  "unlinkImage",
  async ({ url, data, notFormData }) => {
    const res = await http.put(url, data, {
      headers: {
        "Content-Type": notFormData
          ? "application/json"
          : "multipart/form-data",
      },
    });
    return res.data;
  }
);

export const deleteCategory = createAsyncThunk(
  "deleteCategory",
  async ({ url, data }) => {
    const res = await fetch(url, {
      method: "DELETE",
      headers: { Authorization: localStorage.getItem("token") },
      body: JSON.stringify(data),
    });
    return await res.json();
  }
);

export const creatCategoryData = createAsyncThunk(
  "creatCategoryData",
  async ({ url, reqBody }) => {
    const response = await http
      .post(url, reqBody, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => response)
      .catch((error) => error.response);

    return response.data;
  }
);

// ---------- SLICE ----------
const categorySlice = createSlice({
  name: "categorySlice",

  initialState: {
    category: null,          // ecommerce categories
    allCategory: null,       // old service api
    EcomCategory: null,      // other ecommerce list

    serviceCategory: [],     // ✅ NEW service list
    servicePages: null,      // ✅ NEW pagination object

    subCategory: null,
    subCategoryData: null,
    subCategoryByParent: null,
    isSubCategoryLoading: false,

    Loading: false,
    createUpdateLoading: false,
    IsLoading: false,
    isPages: null,           // ecommerce pagination
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      // -------- SERVICE CATEGORY --------
      .addCase(getServiceCategory.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getServiceCategory.fulfilled, (state, action) => {
        state.Loading = false;
        state.serviceCategory = action.payload?.data || [];
        state.servicePages = {
          ...action.payload,
          totalPages: action.payload?.totalPages || Math.ceil((action.payload?.totalCategory || action.payload?.data?.length || 0) / 10) || 1
        };
      })
      .addCase(getServiceCategory.rejected, (state) => {
        state.Loading = false;
      })

      // -------- NULL PARENT CATEGORY --------
      .addCase(getNullParentCategory.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getNullParentCategory.fulfilled, (state, action) => {
        state.Loading = false;
        state.serviceCategory = action.payload?.data || [];
        state.servicePages = {
          ...action.payload,
          totalPages: action.payload?.totalPages || Math.ceil((action.payload?.totalCategory || action.payload?.data?.length || 0) / 10) || 1
        };
      })
      .addCase(getNullParentCategory.rejected, (state) => {
        state.Loading = false;
      })

      // -------- OLD SERVICE API --------
      .addCase(getCategory.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getCategory.fulfilled, (state, action) => {
        state.Loading = false;
        state.allCategory = action.payload?.data;
      })
      .addCase(getCategory.rejected, (state) => {
        state.Loading = false;
      })

      // -------- ECOMMERCE CATEGORY --------
      .addCase(getEcomCategory.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getEcomCategory.fulfilled, (state, action) => {
        state.Loading = false;
        state.EcomCategory = action.payload?.data;
      })
      .addCase(getEcomCategory.rejected, (state) => {
        state.Loading = false;
      })

      // -------- GLOBAL (ADMIN) ECOM CATEGORY --------
      .addCase(getGlobalCategory.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getGlobalCategory.fulfilled, (state, action) => {
        state.Loading = false;
        state.category = action.payload?.data || [];
        state.isPages = action.payload?.totalPages || Math.ceil((action.payload?.totalCategory || action.payload?.data?.length || 0) / 10) || 1;
      })
      .addCase(getGlobalCategory.rejected, (state) => {
        state.Loading = false;
      })

      // -------- GLOBAL CATEGORY APPEND (infinite scroll) --------
      .addCase(getGlobalCategoryAppend.fulfilled, (state, action) => {
        const newData = action.payload?.data || [];
        state.category = [...(state.category || []), ...newData];
        state.isPages = action.payload?.totalPages || state.isPages;
      })

      // -------- CREATE / UPDATE --------
      .addCase(creatCategoryData.pending, (state) => {
        state.createUpdateLoading = true;
      })
      .addCase(creatCategoryData.fulfilled, (state) => {
        state.createUpdateLoading = false;
      })
      .addCase(creatCategoryData.rejected, (state) => {
        state.createUpdateLoading = false;
      })

      .addCase(updateCategory.pending, (state) => {
        state.createUpdateLoading = true;
      })
      .addCase(updateCategory.fulfilled, (state) => {
        state.createUpdateLoading = false;
      })
      .addCase(updateCategory.rejected, (state) => {
        state.createUpdateLoading = false;
      })

      // -------- SUBCATEGORY --------
      .addCase(getSubCategory.pending, (state) => {
        state.IsLoading = true;
      })
      .addCase(getSubCategory.fulfilled, (state, action) => {
        state.IsLoading = false;
        state.subCategory = action.payload?.data;
        state.subCategoryData = action.payload;
      })
      .addCase(getSubGlobalCategory.fulfilled, (state, action) => {
        state.IsLoading = false;
        state.subCategory = action.payload?.data;
        state.subCategoryData = action.payload;
      })
      .addCase(getSubCategory.rejected, (state) => {
        state.IsLoading = false;
      })

      // -------- SUBCATEGORY BY PARENT --------
      .addCase(getSubcategoryByPcategory.pending, (state) => {
        state.isSubCategoryLoading = true;
      })
      .addCase(getSubcategoryByPcategory.fulfilled, (state, action) => {
        state.isSubCategoryLoading = false;
        state.subCategoryByParent = action.payload?.data;
      })
      .addCase(getSubcategoryByPcategory.rejected, (state) => {
        state.isSubCategoryLoading = false;
      });
  },
});

export default categorySlice.reducer;
